module.exports = __webpack_public_path__ + "static/img/cruelty_child_1_en.9e543c72.png";